import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Attachment } from '../../models/attachment/attachment.model';

@Injectable()
export class AttachmentApiService {
  private readonly baseUrl = `${environment.apiBaseUrl}/files`;

  constructor(private http: HttpClient) {}

  list(entityType: string, entityId: number): Observable<Attachment[]> {
    return this.http.get<Attachment[]>(`${this.baseUrl}`, {
      params: { entityType, entityId: entityId.toString() }
    });
  }

  upload(entityType: string, entityId: number, file: File): Observable<Attachment> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('entityType', entityType);
    formData.append('entityId', entityId.toString());

    return this.http.post<Attachment>(`${this.baseUrl}`, formData);
  }

  download(id: string): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/${id}/download`, {
      responseType: 'blob'
    });
  }

  remove(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }
}
